/* eslint-disable import/prefer-default-export */
export { initialState, reducer } from './reducer';
